<template>
  <div class="main_right lhb-class">
    <!--<bread-crumb :breadcrumb="config.breadcrumb" />-->
    <div class="statistics margin-bottom-8">
      <title-bar :title="['概览']" />
      <!--<div class="flex-align-center margin-top-12">-->
        <!--<span class="margin-right-16">营业单位</span>-->
        <!--<input-tree class="input-tree width-217"-->
                    <!--:fetch="config.tree.fetch"-->
                    <!--:default-value="1"-->
                    <!--@input="handleEntitySelected"-->
        <!--/>-->
      <!--</div>-->
      <!-- region 日期选择 -->
      <input-date-range v-model="dateRange" class="margin-top-12"
                        :picker-options="config.pickerOptions"
                        @change="handleDateChange"
      />
      <!--&lt;!&ndash; endregion 日期选择 &ndash;&gt;-->
      <!--<input-date class="input-date" size="small"-->
                  <!--v-model="date" @change="getSubData" />-->
    </div>
    <div class="overview">
      <overview-box title="缴费总额 (元)"
                    :content="summary.transMoney"
                    :annularRatio="summary.transBillMoneyRate"
                    :tip="moneyTip"
                    @click.native="handleOverviewBoxClick('transMoney')"
      />
      <overview-box title="缴费笔数 (笔)"
                    :content="summary.transCount"
                    :annularRatio="summary.transBillCountRate"
                    :tip="countTip"
                    @click.native="handleOverviewBoxClick('transCount')"
      />
    </div>
    <div class="statistics">
      <title-bar :title="[yKey === 'transMoney' ? '订单总额走势图' : '订单笔数走势图']" />
    </div>
    <div id="tradeOverviewEChartsView"></div>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import TitleBar from '../../../components/common/di-ding/common/title-bar'
  import OverviewBox from './_overview-box'
  import echarts from 'echarts'
  // import InputTree from '../../../common/inputs/input-tree'
  import {api} from '../../api/electronic-control'
  import InputDateRange from '../../../components/common/inputs/input-date-range'
  import {inputDateHelper} from '../../../components/common/inputs/_input-date-helper'
  import InputDate from '../../../components/common/inputs/input-date'
  import {spDateFormat, transformMoney} from '../../../utils/util'
  import {commonConfig} from '../common'
  import {errorHandler} from '../../../utils/errorHandler'

  const breadcrumb = [
    commonConfig.firstBreadcrumb,
    commonConfig.tradeOverview,
    {label: '交易总览'}
  ]

  const title = []

  export default {
    components: {
      InputDate,
      InputDateRange,
      OverviewBox,
      TitleBar,
      BreadCrumb
    },
    name: 'electronic-statistics',
    data () {
      return {
        config: {
          breadcrumb,
          title,
          pickerOptions: {
            shortcuts: [
              inputDateHelper.OPTIONS.SHORTCUT.A_WEEK,
              inputDateHelper.OPTIONS.SHORTCUT.TWO_WEEKS,
              inputDateHelper.OPTIONS.SHORTCUT.A_MONTH
            ],
            disabledDate: inputDateHelper.OPTIONS.DISABLED_DATE.CATCHFORTH
          },
          transformMoney: m => transformMoney(m, '0.00'),
        },
        requestBody: {},
        data: [],
        summary: {
          transMoney: '0.00',
          transCount: '0'
        },
        moneyTip: '扣除交易退款的交易订单金额总和',
        countTip: '扣除交易退款的交易订单笔数总和',
        // date: inputDateHelper.time.zeroClockOfYesterday(),
        dateRange: inputDateHelper.time.lastWeekRange(),
        domEChart: null,
        listCache: null,
        yKey: 'transMoney'
      }
    },
    created () {
      this.render()
    },
    mounted () {
      this.domEChart = document.getElementById('tradeOverviewEChartsView')
    },
    methods: {
      render () {
        this.requestBody.startTime = spDateFormat(this.dateRange[0])
        this.requestBody.endTime = spDateFormat(this.dateRange[1])
        this.getSubData()
        this.getData()
      },

      getSubData () {
        api.getElectricOverviewSummary(this.requestBody)
          .then(data => {
            if (data) {
              data.transMoney = data.transMoney.toString()
              data.transCount = data.transCount.toString()
              this.summary = data
            }
          })
      },

      getData () {
        this.loading = true
        api.getElectricOverviewList(this.requestBody)
          .then(list => {
            this.listCache = list
            return list
          })
          .then(this.transformDataAndRender)
          .catch(errorHandler('请求错误'))
          .then(this.loaded)
      },

      handleOverviewBoxClick (yKey) {
        this.yKey = yKey
        this.transformDataAndRender(this.listCache)
      },

      transformDataAndRender (list) {
        list = list
          .map(it => {
            it.x = it['transSummaryTime'].substring(0, 10)
            it.y = it[this.yKey]
            return it
          })
          .reduce((sum, item) => {
            sum[0].push(item.x)
            sum[1].push(item.y)
            return sum
          }, [[], []])
        this.renderEChart(list)
      },

      renderEChart ([x, y]) {
        const option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            containLabel: true
          },
          xAxis: {
            name: '时间',
            type: 'category',
            data: x
          },
          yAxis: {
            name: this.yKey === 'transMoney' ? '金额' : '笔数',
            type: 'value'
          },
          series: [{
            name: this.yKey === 'transMoney' ? '金额' : '笔数',
            data: y,
            type: 'line',
            smooth: true,
            itemStyle: {
              normal: {
                color: '#0065FE'
              }
            }
          }]
        }
        // noinspection JSUnresolvedFunction
        const myChart = echarts.init(this.domEChart)
        myChart.setOption(option)
      },

      handleEntitySelected (val) {
        this.requestBody.businessEntityId = val.id
        this.render()
      },

      handleDateChange () {
        this.requestBody.startTime = this.dateRange[0]
        this.requestBody.endTime = this.dateRange[1]
        this.render()
      },
    }
  }
</script>

<style scoped lang="less">
  .margin-top-12 {
    margin-top: 12px;
  }

  .overview {
    display: flex;
    div {
      flex: auto;
    }
  }

  .breadcrumb {
  	margin-bottom: 0 !important;
  }

  .statistics {
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
  }

  #tradeOverviewEChartsView {
    border: 1px solid #D7D7D7;
    margin: 10px 30px;
    height: 450px;
  }

  .input-tree {
    height: 32px;
    width: 215px;
    color: #c0c4cf;
    font-size: 14px;
    border-radius: 4px;
  }

  .date-picker {
    width: 320px;
    margin-right: 30px;
  }

  .input-date {
    margin-right: 30px;

  }
</style>

<style>
  /*noinspection CssUnusedSymbol*/
  .lhb-class .el-date-editor .el-range-separator {
    padding: 0;
  }
</style>





// WEBPACK FOOTER //
// src/view/ElectronicControl/electronic-statistics/electronic-statistics.vue